import React from 'react';
import './intro.scss';
import Mood from '@material-ui/icons/Mood';
import RSSsert from './rss-sert.jpg';

const context = {
    ru: {
        str2: 'Я люблю JavaScript && Typescript ...',
        str3: 'Знаю о React && Angular && NodeJS  ...',
        str4: 'И слышал, что существует HTML и CSS ...',
        str5: 'Ищу вакансию разработчика интерфейсов или fullstack, но с уклоном на фронтенд',
        str6: 'Знаю разницу между SPA & MPA, CSR & SSR ',
        str7: 'Люблю изучать новые технологии...',
        str8: 'Текущий рабочий стэк: Angular 11 && Devextreme 20',
        str9: 'Сертификаты',
    },
    en: {
        str2: 'I love JavaScript && Typescript ...',
        str3: 'I know about React && Angular && NodeJS ...',
        str4: 'And I heard about HTML & CSS ...',
        str5: 'I am looking for a job Frontend developer or fullstack with focus on a frontend',
        str6: 'I know differece between SPA & MPA, CSR & SSR',
        str7: 'I Like to learn new technologies',
        str8: 'Current working stack: Angular 11 && Devextreme 20',
        str9: 'Certificates',
    },
};

const Intro = ({ lang }) => {
    const { str2, str3, str4, str5, str6, str7, str8, str9 } = context[lang];
    return (
        <div className='Intro'>
            <p>{str2}</p>
            <p>{str3}</p>
            <p>
                {str4} <Mood />
            </p>
            <p>{str6}</p>
            <p>{str7}</p>
            <p>{str8}</p>
            <hr />
            <h3>{str5}</h3>
            <hr />
            <p>{str9}</p>
            <img src={RSSsert} alt='sertificate rsschool' />
        </div>
    );
};

export default Intro;
